import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TemplatesState } from '../reducers/templates.reducer';

export const templatesState: any = createFeatureSelector<TemplatesState>('templates');

export const templatesData = createSelector(templatesState, (state: any) => {
  return state.data;
});

export const templateData = createSelector(templatesState, (state: any) => {
  return state.templateData;
});

export const loader = createSelector(templatesState, (state: any) => {
  return state.loader;
});
